<div>
    <div class="title textBlock">
        <p class="h1 text-center">Chirowandeling</p>
    </div>
    <div class="textBlock">
    <div>
        <p class="h2 text-center">Wandelinformatie</p>
        <hr>
    </div>
    <div>
        <p class="text-center d-block margin">
            Dit is een familie-vriendelijke wandeling van ongeveer 5 kilometer. De wandeling is zo uitgestippeld dat deze kan gewandeld worden met een buggy. Echter zullen buggywandelaars
            op een bepaald punt worden omgeleid via een korte alternatieve route. Hierdoor zullen ze een kort stukje van de tocht verliezen.
        </p>
    </div>
    <div>
        <p class="text-center d-block margin">
            Deelnemers zullen tijdens de wandeling verscheidene weetjes over de Chiro of over medewandelaars kunnen ontdekken. Samen kunnen jullie nog eens terug denken aan jullie eigen tijd in de jeugdbeweging.
        </p>
    </div>
    </div>
    <div class="textBlock">
    <div>
        <p class="h2 text-center">Technische informatie</p>
        <hr>
    </div>
    <div>
        <p class="text-center d-block margin">
            De routebeschrijving van deze tocht zal digitaal gebeuren. Bij het vertrek aan onze Chiro zal er een QR-code staan die jullie zullen kunnen scannen. 
            Na elk stukje tekst zal er een knop zijn die jullie zal begeleiden naar de volgende locatie.
        </p>
    </div>
    </div>
    <div class="textBlock">
        <p class="text-center d-block margin">
            Wij wensen jullie alvast veel wandelplezier!<br>
            De organisatie, leiding en VB van Chiro Sint-Jozef Bloemendaal
        </p>
    </div>
    <div class="text-center">
        <div *ngIf="!enableButton" class="textBlock">
            <p>Deze knop zal actief worden op <b>12 februari 2021</b>.</p>
        </div>
        
        <button type="button" class="btn btn-primary" [routerLink]="'/vertrek'" [disabled]="!enableButton">START</button>
    </div>
</div>